import React from 'react';
import { BrowserRouter, Route, Switch, useParams } from 'react-router-dom';
import { PrivateRoute } from '../../../router/PrivateRoute';
import { useGetFile } from '../hooks/useGetFile';
import { CampaignEditorWrapper } from './CampaignEditorWrapper';
import { CampaignFormEditorWrapper } from './CampaignFormEditorWrapper';
import { CampaignManagerWrapper } from './CampaignManagerWrapper';
import { CampaignOverviewWrapper } from './CampaignOverviewWrapper';
import SubmissionCompareViewWrapper from './SubmissionCompareViewWrapper';

export function CampaignRouter({ match }) {
  return (
    <Switch>
      <PrivateRoute path={`${match.url}/:parentId/forms/:formId/edit`} component={CampaignFormEditorWrapper} exact />
      <PrivateRoute path={`${match.url}/:parentId/forms/:formId/compare/`} component={SubmissionCompareViewWrapper} />
      <PrivateRoute path={`${match.url}/:parentId`} component={MimeTypeSwitch} />
      <PrivateRoute path={`${match.url}/`} component={CampaignOverviewWrapper} />
    </Switch>
  );
}

function MimeTypeSwitch({ match }) {
  const { parentId } = useParams<{ parentId: string }>();
  const { data: parent } = useGetFile(parentId);
  switch (parent?.type) {
    case 'campaign':
      return <CampaignEditorWrapper match={match} />;
    default:
      return <CampaignManagerWrapper match={match} />;
  }
}
